<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :large="large"
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon><span v-if="edit === false">Evidência</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-task-combobox
              :filter="payload"
            ></app-task-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Descrição"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { evidenceAPI } from '@/modules/evidence'
import { AppTaskCombobox } from '@/modules/task'

export default {
  name: 'AppModalInsertEvidence',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {
    AppTaskCombobox
  },
  data () {
    return {
      payload: {},
      dialog: false
    }
  },
  mounted () {
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    onConfirm () {
      if (this.edit === true) {
        evidenceAPI.update(this.payload)
          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
      } else {
        evidenceAPI.create(this.payload)
          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
      }
    }
  },
  watch: {
    'object' (newValue, oldValue) {
      this.payload = newValue
    }
  }
}
</script>
